<template>
  <div class="analytic-tab mt-2">
    <!-- col-12  -->
    <!-- <div class="row mt-3"> -->
    <!-- <div class="col-12"> -->
    <Switcher :padding="'p-0'" :inline="false" v-model="analytics.ga.active" type="switch" custom :disableBody="shopInfo.gaLoggedIn" @input="toggleGA">
      <div class="d-flex">
        <div class="switcher-info flex-grow-1">
          <p class="typo-paragraph14 typo-regular text-light-high mb-half noselect">
            {{ $t("accountSettings.analytics.ga.title") }}
          </p>
          <p class="typo-paragraph12 typo-regular text-light-low" v-html="$t('accountSettings.analytics.ga.subtitle')" @click.stop></p>
        </div>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M31.983 16.2994C31.983 14.9884 31.8741 14.0317 31.6385 13.0396H16.3186V18.9569H25.3111C25.1298 20.4274 24.1508 22.642 21.9751 24.1301L21.9446 24.3282L26.7885 27.9952L27.1241 28.0279C30.2062 25.2463 31.983 21.1537 31.983 16.2994Z" fill="#4285F4" />
          <path d="M16.3188 31.8902C20.7243 31.8902 24.4228 30.4728 27.1243 28.0279L21.9753 24.1301C20.5974 25.0691 18.7481 25.7246 16.3188 25.7246C12.0039 25.7246 8.34162 22.9432 7.03613 19.0986L6.84477 19.1145L1.80806 22.9236L1.74219 23.1026C4.4254 28.3113 9.93695 31.8902 16.3188 31.8902Z" fill="#34A853" />
          <path d="M7.03611 19.0987C6.69164 18.1066 6.49229 17.0435 6.49229 15.9451C6.49229 14.8466 6.69164 13.7837 7.01799 12.7915L7.00886 12.5803L1.90901 8.70996L1.74215 8.78752C0.636269 10.949 0.00170898 13.3762 0.00170898 15.9451C0.00170898 18.5141 0.636269 20.9412 1.74215 23.1026L7.03611 19.0987Z" fill="#FBBC05" />
          <path d="M16.3188 6.16537C19.3828 6.16537 21.4496 7.45869 22.6281 8.53948L27.2331 4.14571C24.4049 1.57679 20.7244 0 16.3188 0C9.93699 0 4.42542 3.57875 1.74219 8.78742L7.01803 12.7915C8.34165 8.94693 12.0039 6.16537 16.3188 6.16537Z" fill="#EB4335" />
        </svg>
      </div>
      <TransitionExpand>
        <div class="pt-2 pb-1" v-if="shopInfo.gaLoggedIn">
          <!-- <hr class="bg-dark-high mb-2" /> -->
          <div class="row">
            <div class="col-12 col-lg-4">
              <label class="mb-1 d-block typo-button14 typo-medium text-light-high">{{ $tc("analytic.ab.account", 2) }}</label>
              <BaseSelect v-model="analytics.ga.gaAccountId" positioning :options="accountOptions" @input="loadProperties(true)" :disabled="!accounts.fetched" :indicating="loading.account" />
            </div>
            <div class="col-12 col-lg-4">
              <label class="mb-1 d-block typo-button14 typo-medium text-light-high" :class="{ opac60: analytics.ga.gaAccountId == '' }">{{ $tc("analytic.ab.property", 2) }}</label>
              <BaseSelect v-model="analytics.ga.gaPropertyId" positioning :options="propertyOptions" @change="updateWebAnalyticTools({ trigger: 'property'})" @input="loadTracks(true)" :disabled="!!(analytics.ga.gaAccountId == '')" :indicating="loading.property" />
            </div>
            <div class="col-12 col-lg-4" v-if="isGA3(analytics.ga.gaPropertyId)">
              <label class="mb-1 d-block typo-button14 typo-medium text-light-high" :class="{ opac60: analytics.ga.gaAccountId == '' || analytics.ga.gaPropertyId == '' }">
                <template v-if="trackType.includes('view')">{{ $tc("analytic.ab.view", 2) }}</template>
                <span v-if="trackType.includes('/')">/</span>
                <template v-if="trackType.includes('stream')">{{ $tc("analytic.ab.stream", 2) }}</template>
              </label>
              <BaseSelect v-model="analytics.ga.gaViewId" :options="trackOptions" @change="updateWebAnalyticTools({ trigger: 'view'})" :disabled="!!(analytics.ga.gaAccountId == '' || analytics.ga.gaPropertyId == '')" :indicating="loading.track" />
            </div>
          </div>
        </div>
      </TransitionExpand>
    </Switcher>
    <!-- <div class="bg-light1 py-3 pl-6 pr-2">
          <div class="pl-2">
            <hr class="bg-dark-high mb-2" />
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4"></div>
              <div class="col-4"></div>
            </div>
          </div>
        </div> -->
    <!-- </div>
    </div> -->
  </div>
</template>

<script>
import Switcher from "@/core/shared/essenstials/Switcher.vue";
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types";
import { actions as accountActions } from "@/store/account/types";
import googleLogin from "@/mixins/googleLogin";
import errorHandle from "@/mixins/errorHandle";
export default {
  components: { Switcher },
  mixins: [googleLogin({}, "popupRunning"), errorHandle()],
  model: {
    prop: "source",
    event: "input"
  },
  props: {
    source: {
      type: Object
    },
    highlight: {
      type: Object
    }
  },
  data: () => ({
    btnGALoading: false,
    popupRunning: false,

    loading: {
      account: false,
      property: false,
      track: false
    },

    properties: [],
    tracks: []
  }),
  computed: {
    ...mapState("analytic", {
      accounts: state => state.accounts
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    isGAActive: {
      get() {
        return this.analytics.ga.active;
      },
      set(val) {
        this.analytics.ga.active = val;
      }
    },
    accountOptions() {
      if (!this.accounts || !this.accounts.fetched) {
        return [];
      }
      return this.accounts.list.map(x => ({
        value: x.id,
        text: x.name
      }));
    },
    trackOptions() {
      if (!this.tracks || !this.tracks.length) {
        return [];
      }
      return this.tracks.map(x => ({
        value: x.id,
        text: x.name
      }));
    },
    propertyOptions() {
      if (!this.properties || !this.properties.length) {
        return [];
      }
      return this.properties.map(x => ({
        value: x.id,
        text: x.name
      }));
    },
    trackType() {
      // if (!this.analytics.ga.gaPropertyId || this.analytics.ga.gaPropertyId == "") {
      //   return "view/stream";
      // }
      // if (this.analytics.ga.gaPropertyId.toUpperCase().startsWith("UA-")) {
      return "view";
      // }
      // return "stream";
    },
    analytics: {
      get() {
        return this.source;
      },
      set(value) {
        this.source = value;
        this.$emit("input", value);
      }
    }
  },
  watch: {
    popupRunning(newV, oldV) {
      if (!newV && oldV) {
        this.isGAActive = this.shopInfo.gaLoggedIn;
      }
    },
    "analytics.ga.gaPropertyId"() {
      this.analytics.ga.gaType = "";
    },
    "shopInfo.gaLoggedIn"(newV) {
      this.isGAActive = this.shopInfo.gaLoggedIn;
      if (newV) {
        this.loadAccounts();
      }
    }
  },
  mounted() {
    this.setOldData();

    // Only load ga data when logged in
    if (this.shopInfo?.gaLoggedIn == true) {
      // load account dropdown values
      this.loadAccounts();
      if (this.analytics.ga.gaAccountId && this.analytics.ga.gaAccountId != "") {
        this.loadProperties();
      }
      if (this.analytics.ga.gaPropertyId && this.analytics.ga.gaPropertyId != "") {
        this.loadTracks();
      }
    }
  },
  methods: {
    ...mapActions("account", {
      getAuthLink: accountActions.ACCOUNT_GET_GOOGLE_AUTH,
      disconnectGA: accountActions.ACCOUNT_DISCONNECT_GOOGLE_ANALYTIC
    }),
    ...mapActions("analytic", {
      fetchAccounts: actions.FETCH_ACCOUNTS_ANALYTIC,
      fetchProperties: actions.FETCH_PROPERTIES_ANALYTIC,
      fetchProfiles: actions.FETCH_PROFILES_ANALYTIC,
      fetchStreams: actions.FETCH_STREAMS_ANALYTIC
    }),
    isGA3(property) {
      const GA3_PROPERTIES_FORMAT = new RegExp('^[UA]\\w+', 'g');
      return GA3_PROPERTIES_FORMAT.test(property);
    },
    updateWebAnalyticTools(options) {
      const isGA3 = this.isGA3(this.analytics.ga.gaPropertyId);
      if (options.trigger === 'property' && isGA3) return;
      if (options.trigger === 'property' && !isGA3) {
        this.analytics.ga.gaType = 'GA4'
      };
      this.$emit("input", this.source);
    },
    setOldData() {
      // this.analytics.ga.active = this.shopInfo.gaLoggedIn;
      // const accountID = this?.shopInfo?.accountInfo?.webAnalyticsTools?.ga?.gaAccountId || "";
      // const propertyID = this?.shopInfo?.accountInfo?.webAnalyticsTools?.ga?.gaPropertyId || "";
      // const trackID = this?.shopInfo?.accountInfo?.webAnalyticsTools?.ga?.gaViewId || "";
      // if (trackID.startsWith("UA-")) {
      //   this.propertyID = trackID;
      //   this.trackID = propertyID;
      // } else {
      //   this.propertyID = propertyID;
      //   this.trackID = trackID;
      // }
    },
    disconnectGoogle() {
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.btnGALoading = true;

      this.disconnectGA()
        .then(() => {
          this.analytics.ga.gaAccountId = null;
          this.analytics.ga.gaPropertyId = null;
          this.analytics.ga.gaViewId = null;
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.btnGALoading = false;
        });
    },
    loginGoogle() {
      this.toggleLoading(true);
      const _this = this;
      this.getAuthLink()
        .then(res => {
          // close loading and notify if authorized
          if (res.authorized) {
            _this.toggleLoading(false);
            _this.gSnackbarCommit({
              message: _this.$t("accountSettings.google.connected"),
              type: "success"
            });
            _this.updateGAuthStatus(true);
            _this.loadProperties(true);
          } else {
            this.openGoogleLoginPopup(res.url);
          }
        })
        .catch(err => {
          const errText = this.getErrorMessage(err);
          _this.gSnackbarCommit({
            message: _this.$t(errText),
            type: "error"
          });
        });
    },
    toggleGA() {
      if (this.shopInfo?.gaLoggedIn == false) {
        this.loginGoogle();
      } else {
        this.disconnectGoogle();
      }
    },
    loadAccounts() {
      this.loading.account = true;
      this.fetchAccounts()
      .catch(error => {
        this.gSnackbarCommit({
          message: this.getErrorMessage(error),
          type: "error"
        });
      })
      .finally(() => {
        this.loading.account = false;
      });
    },
    loadProperties(reset = false) {
      this.loading.property = true;
      Promise.all([
        this.fetchProperties({ id: this.analytics.ga.gaAccountId }),
        this.fetchProperties({ id: this.analytics.ga.gaAccountId, isGA4: true }),
      ])
      .then(values => {
        this.properties = [...values.flat()];
      })
      .catch(err => {
        if (err?.response?.data?.message == "insufficientPermissions") {
          this.gDialogCommit({
            type: "error",
            message: "error.insufficientPermissions"
          });
        } else {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        }
      })
      .finally(() => {
        this.loading.property = false;
        if (reset) {
          this.analytics.ga.gaPropertyId = "";
          this.analytics.ga.gaViewId = "";
        }
      });
    },
    loadTracks(reset = false) {
      if (!this.isGA3(this.analytics.ga.gaPropertyId)) return;
      let funcName = "fetchProfiles";
      // if (this.trackType == "stream") {
      //   funcName = "fetchStreams";
      // }
      this.loading.track = true;
      this[funcName]({ accountID: this.analytics.ga.gaAccountId, propertyID: this.analytics.ga.gaPropertyId })
        .then(res => {
          this.tracks = res;
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.loading.track = false;
          if (reset) {
            this.analytics.ga.gaViewId = "";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.analytic-tab {
  z-index: 10;
}
</style>
